
const state = {
  classId: '',
  className: '',
  semester: '',
  leftDate: '',
  rightDate: '',
  gradeLevel: '',
  dataInfo: {}
}

const mutations = {
  SET_CLASSID: (state, classId = '') => {
    state.classId = classId
  },
  SET_DATA_INFO: (state, dataInfo = '') => {
    state.dataInfo = dataInfo
  },
  SET_GRADELEVEL: (state, gradeLevel = '') => {
    state.gradeLevel = gradeLevel
  },
  SET_CLASSNAME: (state, className = '') => {
    state.className = className
  },
  SET_SEMESTER: (state, semester = '') => {
    state.semester = semester
  },
  SET_LEFTDATE: (state, leftDate = '') => {
    state.leftDate = leftDate
  },
  SET_RIGHTDATE: (state, rightDate = '') => {
    state.rightDate = rightDate
  }
}

const actions = {
  setClassId({ commit }, classId) {
    commit('SET_CLASSID', classId)
  },
  gradeLevel({ commit }, gradeLevel) {
    commit('SET_GRADELEVEL', gradeLevel)
  },
  setClassName({ commit }, className) {
    commit('SET_CLASSNAME', className)
  },
  setSemester({ commit }, semester) {
    commit('SET_SEMESTER', semester)
  },
  setLeftDate({ commit }, leftDate) {
    commit('SET_LEFTDATE', leftDate)
  },
  setRightDate({ commit }, rightDate) {
    commit('SET_RIGHTDATE', rightDate)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
